import { FlexRow, MaterialIcon, StyledSearchBar } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { memo, useEffect } from 'react';
import { useStyles } from '../../../hooks/useStyles';
import { StyledTooltip } from '../../ui/StyledTooltip';
import { useFleetAssets } from '../hooks/useFleetAssets';
import { FleetAssetsFilters } from './FleetAssetsFilters';

function FleetAssetsFiltersBar() {
  const { css, theme } = useStyles();
  const { hasActiveFilters, onReload, search, onChangeSearch, resetAllFilters, resetFilters } = useFleetAssets();

  useEffect(() => {
    return () => {
      resetAllFilters();
    };
  }, []);

  return (
    <FlexRow
      classNames={css({ alignItems: 'center' })}
      gap={theme.sizing.scale100}
    >
      <FlexRow
        classNames={css({ flex: '1', alignItems: 'center' })}
        gap={theme.sizing.scale100}
      >
        <span className={css({ flexGrow: '0.5' })}>
          <StyledSearchBar
            name="fleet-asset-search"
            value={search}
            onChange={onChangeSearch}
            clearable
            noMargin
          />
        </span>
        <FleetAssetsFilters />
        <StyledTooltip
          content="Limpiar filtros"
          showArrow={false}
        >
          <Button
            size="mini"
            shape="round"
            onClick={resetFilters}
            kind="tertiary"
            disabled={!hasActiveFilters}
          >
            <MaterialIcon
              name="clear"
              size="mini"
              color={!hasActiveFilters ? theme.colors.contentStateDisabled : undefined}
            />
          </Button>
        </StyledTooltip>
      </FlexRow>
      <StyledTooltip
        content="Recargar tabla"
        showArrow={false}
      >
        <Button
          size="compact"
          shape="square"
          onClick={onReload}
          kind="tertiary"
        >
          <MaterialIcon name="refresh" />
        </Button>
      </StyledTooltip>
    </FlexRow>
  );
}

export default memo(FleetAssetsFiltersBar);
